<script setup lang="ts">
/**
 * Storage-full banner — brief §18. Non-modal, persistent while saves fail.
 * In-memory work is intact; offers cleanup or the app (never a hard block).
 */
import { Capacitor } from '@capacitor/core';
import { useSketchbookStore } from '@/stores/sketchbook';
import { useUiStore } from '@/stores/ui';

const sketchbook = useSketchbookStore();
const ui = useUiStore();
const isNative = Capacitor.isNativePlatform();
</script>

<template>
  <div v-if="sketchbook.storageWarning" class="storage-banner" role="alert">
    <span>Storage full — changes aren’t being saved. Your drawing is safe on screen.</span>
    <button @click="ui.showGallery = true">Delete old sketches</button>
    <button v-if="!isNative" @click="ui.openPaywall('export')">Get the app</button>
  </div>
</template>

<style scoped>
.storage-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 12px;
  background: #3a2a1a;
  border-bottom: 1px solid #6a4a2a;
  color: var(--text-primary);
  font-size: 13px;
}

.storage-banner button {
  min-height: 30px;
  padding: 2px 10px;
  background: transparent;
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--text-primary);
  cursor: pointer;
}
</style>
